import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=34a58f9a&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=ts"
export * from "./ShipmentDetails.vue?vue&type=script&lang=ts"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=34a58f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a58f9a",
  null
  
)

export default component.exports